// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AbsencesDeleteData, AbsencesDeleteResponses, AbsencesGetData, AbsencesGetResponses, AbsencesPostData, AbsencesPostResponses, AcknowledgeEmergencyViaWebUiData, AcknowledgeEmergencyViaWebUiErrors, AcknowledgeEmergencyViaWebUiResponses, ActivatePublisherData, ActivatePublisherErrors, ActivatePublisherResponses, ActivateRouteData, ActivateRouteErrors, ActivateRouteResponses, AddCalendarEventData, AddCalendarEventErrors, AddCalendarEventResponses, AllowPublishersToMaintainRoutePreferencesData, AllowPublishersToMaintainRoutePreferencesErrors, AllowPublishersToMaintainRoutePreferencesResponses, AnalyticsGetAssignmentOverviewData, AnalyticsGetAssignmentOverviewResponses, AnalyticsGetBranchReportData, AnalyticsGetBranchReportResponses, AnalyticsGetBranchReportsData, AnalyticsGetBranchReportsResponses, AnalyticsGetCircuitReports2Data, AnalyticsGetCircuitReports2Responses, AnalyticsGetCircuitReportsData, AnalyticsGetCircuitReportsResponses, AnalyticsGetMonthReportData, AnalyticsGetMonthReportResponses, AnalyticsGetMonthReportsData, AnalyticsGetMonthReportsResponses, AnalyticsProlongCircuitReportAvailabilityData, AnalyticsProlongCircuitReportAvailabilityResponses, AnalyticsTurnReportsData, AnalyticsTurnReportsResponses, AuditGet2Data, AuditGet2Responses, AuditGetData, AuditGetResponses, BlobsGetBlobData, BlobsGetBlobResponses, CalendarsCreateCalendarData, CalendarsCreateCalendarResponses, CalendarsDisableCalendarData, CalendarsDisableCalendarResponses, CalendarsGetMyCalendarUrlData, CalendarsGetMyCalendarUrlResponses, CircuitsDeleteData, CircuitsDeleteResponses, CircuitsGet2Data, CircuitsGet2Responses, CircuitsGetData, CircuitsGetResponses, CircuitsPostData, CircuitsPostResponses, CircuitsPutData, CircuitsPutResponses, CongregationsDeleteData, CongregationsDeleteResponses, CongregationsGet2Data, CongregationsGet2Responses, CongregationsGetData, CongregationsGetResponses, CongregationsPostData, CongregationsPostResponses, CongregationsPutData, CongregationsPutResponses, CreateCircuitData, CreateCircuitErrors, CreateCircuitResponses, CreateCongregationData, CreateCongregationErrors, CreateCongregationResponses, CreateDepotData, CreateDepotErrors, CreateDepotResponses, CreateFolderData, CreateFolderErrors, CreateFolderResponses, CreatePublisherData, CreatePublisherErrors, CreatePublisherResponses, CreateRouteData, CreateRouteErrors, CreateRouteResponses, CreateTenantData, CreateTenantResponses, CutoffDatesFinalizeUntilData, CutoffDatesFinalizeUntilDryRunData, CutoffDatesFinalizeUntilDryRunResponses, CutoffDatesFinalizeUntilResponses, CutoffDatesGetData, CutoffDatesGetResponses, CutoffDatesReleaseUntilData, CutoffDatesReleaseUntilDryRunData, CutoffDatesReleaseUntilDryRunResponses, CutoffDatesReleaseUntilResponses, DashboardsGetData, DashboardsGetMyDashboardData, DashboardsGetMyDashboardResponses, DashboardsGetResponses, DeactivatePublisherData, DeactivatePublisherErrors, DeactivatePublisherResponses, DeactivateRouteData, DeactivateRouteErrors, DeactivateRouteResponses, DeleteCalendarEventData, DeleteCalendarEventErrors, DeleteCalendarEventResponses, DeleteCircuitData, DeleteCircuitErrors, DeleteCircuitResponses, DeleteCongregationData, DeleteCongregationErrors, DeleteCongregationResponses, DeleteDepotData, DeleteDepotErrors, DeleteDepotResponses, DeleteDocumentData, DeleteDocumentErrors, DeleteDocumentResponses, DeleteFolderData, DeleteFolderErrors, DeleteFolderResponses, DeleteParticipantRoutePreferenceData, DeleteParticipantRoutePreferenceErrors, DeleteParticipantRoutePreferenceResponses, DeletePublisherData, DeletePublisherErrors, DeletePublisherResponses, DeleteRouteData, DeleteRouteErrors, DeleteRouteResponses, DeleteRouteScheduleData, DeleteRouteScheduleErrors, DeleteRouteScheduleResponses, DeleteTenantData, DeleteTenantResponses, DepotsDeleteData, DepotsDeleteResponses, DepotsGet2Data, DepotsGet2Responses, DepotsGetData, DepotsGetResponses, DepotsPostData, DepotsPostResponses, DepotsPutData, DepotsPutResponses, DisableFeatureData, DisableFeatureErrors, DisableFeatureResponses, DocumentsGetCircuitReportData, DocumentsGetCircuitReportResponses, DownloadDocumentData, DownloadDocumentErrors, EnableFeatureData, EnableFeatureErrors, EnableFeatureResponses, EnterEmergencyModeData, EnterEmergencyModeErrors, EnterEmergencyModeResponses, ErrorsHttp400Data, ErrorsHttp400Responses, ErrorsHttp500Data, ErrorsHttp500Responses, ExperiencesCreateEventData, ExperiencesCreateEventResponses, ExperiencesCreateExperienceData, ExperiencesCreateExperienceResponses, ExperiencesGetAllData, ExperiencesGetAllResponses, ExperiencesGetData, ExperiencesGetEventsData, ExperiencesGetEventsResponses, ExperiencesGetResponses, ExperiencesSetPositiveData, ExperiencesSetPositiveResponses, ExperiencesSetStateData, ExperiencesSetStateResponses, ExperiencesSetTitleData, ExperiencesSetTitleResponses, ExperiencesUpdateEventData, ExperiencesUpdateEventResponses, ExportPublishersToExcelData, ExportPublishersToExcelErrors, ExportPublishersToVCardData, ExportPublishersToVCardErrors, ExportPublishersToVCardResponses, FetchAuditEventsData, FetchAuditEventsErrors, FetchAuditEventsResponses, FetchCircuitData, FetchCircuitErrors, FetchCircuitResponses, FetchCircuitsData, FetchCircuitsErrors, FetchCircuitsResponses, FetchCongregationData, FetchCongregationErrors, FetchCongregationResponses, FetchCongregationsData, FetchCongregationsErrors, FetchCongregationsResponses, FetchContactInfoData, FetchContactInfoErrors, FetchContactInfoResponses, FetchCurrentEmergencyData, FetchCurrentEmergencyErrors, FetchCurrentEmergencyResponses, FetchCurrentEmergencyStateData, FetchCurrentEmergencyStateErrors, FetchCurrentEmergencyStateResponses, FetchDepotData, FetchDepotErrors, FetchDepotResponses, FetchDepotsData, FetchDepotsErrors, FetchDepotsResponses, FetchFeatureFlagsData, FetchFeatureFlagsErrors, FetchFeatureFlagsResponses, FetchFolderContentData, FetchFolderContentErrors, FetchFolderContentResponses, FetchMessagingSettingsData, FetchMessagingSettingsErrors, FetchMessagingSettingsResponses, FetchParticipantPreferencesData, FetchParticipantPreferencesErrors, FetchParticipantPreferencesResponses, FetchProjectCalendarMonthData, FetchProjectCalendarMonthErrors, FetchProjectCalendarMonthResponses, FetchProjectCalendarWeekData, FetchProjectCalendarWeekErrors, FetchProjectCalendarWeekResponses, FetchProjectData, FetchProjectErrors, FetchProjectNameData, FetchProjectNameErrors, FetchProjectNameResponses, FetchProjectResponses, FetchPublisherData, FetchPublisherEmergencyReportByPublisherIdData, FetchPublisherEmergencyReportByPublisherIdErrors, FetchPublisherEmergencyReportByPublisherIdResponses, FetchPublisherErrors, FetchPublisherProfileData, FetchPublisherProfileErrors, FetchPublisherProfileResponses, FetchPublisherResponses, FetchPublishersData, FetchPublishersErrors, FetchPublishersResponses, FetchRouteData, FetchRouteErrors, FetchRouteResponses, FetchRouteScheduleData, FetchRouteScheduleErrors, FetchRouteScheduleResponses, FetchRoutesData, FetchRoutesErrors, FetchRoutesResponses, FetchSettingsData, FetchSettingsErrors, FetchSettingsResponses, FetchTenantData, FetchTenantResponses, FetchTenantsData, FetchTenantsResponses, GetDocsData, GetDocsResponses, GetE2eTestTimeNowData, GetE2eTestTimeNowResponses, GetPublisherImportTemplateData, GetPublisherImportTemplateErrors, GetUserInfoData, GetUserInfoResponses, ImportHolidaysData, ImportHolidaysErrors, ImportHolidaysResponses, ImportPublishersFromExcelData, ImportPublishersFromExcelErrors, ImportPublishersFromExcelResponses, InAppNotificationsGetMyInAppNotificationsData, InAppNotificationsGetMyInAppNotificationsResponses, InAppNotificationsGetMyUnreadInAppNotificationsData, InAppNotificationsGetMyUnreadInAppNotificationsResponses, InAppNotificationsMarkAsReadData, InAppNotificationsMarkAsReadResponses, IsRouteOpenForShiftData, IsRouteOpenForShiftErrors, IsRouteOpenForShiftResponses, LanguagesGetData, LanguagesGetResponses, LeaveEmergencyModeData, LeaveEmergencyModeErrors, LeaveEmergencyModeResponses, MakeRouteDisfavoredData, MakeRouteDisfavoredErrors, MakeRouteDisfavoredResponses, MakeRoutePreferredData, MakeRoutePreferredErrors, MakeRoutePreferredResponses, MergeCircuitsData, MergeCircuitsErrors, MergeCircuitsResponses, MergeCongregationsData, MergeCongregationsErrors, MergeCongregationsResponses, MergeDepotsData, MergeDepotsErrors, MergeDepotsResponses, MoveFolderData, MoveFolderErrors, MoveFolderResponses, NewsEntriesDeleteData, NewsEntriesDeleteResponses, NewsEntriesGet2Data, NewsEntriesGet2Responses, NewsEntriesGetCurrentNewsData, NewsEntriesGetCurrentNewsResponses, NewsEntriesGetData, NewsEntriesGetNewsStatisticsData, NewsEntriesGetNewsStatisticsResponses, NewsEntriesGetResponses, NewsEntriesMarkNewsEntryAsReadData, NewsEntriesMarkNewsEntryAsReadResponses, NewsEntriesMarkNewsEntryAsUnreadData, NewsEntriesMarkNewsEntryAsUnreadResponses, NewsEntriesPostData, NewsEntriesPostResponses, NewsEntriesPutData, NewsEntriesPutResponses, NewsEntriesUploadAttachmentData, NewsEntriesUploadAttachmentResponses, PlanningSupportGenerateDraftData, PlanningSupportGenerateDraftResponses, PlanningSupportGetDraftData, PlanningSupportGetDraftResponses, PlanningSupportPerformPlanningData, PlanningSupportPerformPlanningResponses, PostE2eTenantSeedData, PostE2eTenantSeedResponses, PostE2eTestTimeNowData, PostE2eTestTimeNowResponses, PostE2eTestTimeResetData, PostE2eTestTimeResetResponses, PublishersDeleteData, PublishersDeleteResponses, PublishersExportData, PublishersExportResponses, PublishersExportVcardData, PublishersExportVcardResponses, PublishersGet2Data, PublishersGet2Responses, PublishersGetData, PublishersGetMeData, PublishersGetMeResponses, PublishersGetProfileData, PublishersGetProfileResponses, PublishersGetResponses, PublishersImportAllData, PublishersImportAllResponses, PublishersImportData, PublishersImportResponses, PublishersInviteData, PublishersInviteResponses, PublishersLockData, PublishersLockResponses, PublishersPostData, PublishersPostResponses, PublishersPutData, PublishersPutResponses, PublishersSearchData, PublishersSearchResponses, PublishersSetProfileData, PublishersSetProfileResponses, RecurrentApplicationsDeleteData, RecurrentApplicationsDeleteResponses, RecurrentApplicationsGetAllOfPublisherData, RecurrentApplicationsGetAllOfPublisherResponses, RecurrentApplicationsGetSingleData, RecurrentApplicationsGetSingleResponses, RecurrentApplicationsPostData, RecurrentApplicationsPostResponses, RecurrentApplicationsPutData, RecurrentApplicationsPutResponses, RenameDocumentData, RenameDocumentErrors, RenameDocumentResponses, RenameFolderData, RenameFolderErrors, RenameFolderResponses, ReportAsSafeViaWebUiData, ReportAsSafeViaWebUiErrors, ReportAsSafeViaWebUiResponses, RepurposeFolderData, RepurposeFolderErrors, RepurposeFolderResponses, RouteSchedulesDeleteRouteScheduleData, RouteSchedulesDeleteRouteScheduleResponses, RouteSchedulesGetRouteScheduleData, RouteSchedulesGetRouteScheduleResponses, RouteSchedulesSaveRouteScheduleData, RouteSchedulesSaveRouteScheduleResponses, RoutesDeleteData, RoutesDeleteResponses, RoutesGet2Data, RoutesGet2Responses, RoutesGetData, RoutesGetResponses, RoutesPostData, RoutesPostResponses, RoutesPrioritizeData, RoutesPrioritizeResponses, RoutesPutData, RoutesPutResponses, SaveRouteScheduleData, SaveRouteScheduleErrors, SaveRouteScheduleResponses, SendTestEmailData, SendTestEmailErrors, SendTestEmailResponses, SendTestSmsData, SendTestSmsErrors, SendTestSmsResponses, SettingsGetSettings2Data, SettingsGetSettings2Responses, SettingsGetSettingsAllData, SettingsGetSettingsAllResponses, SettingsGetSettingsData, SettingsGetSettingsResponses, SettingsSetSettings2Data, SettingsSetSettings2Responses, SettingsSetSettingsData, SettingsSetSettingsResponses, SettingsValidTimeZoneInfosData, SettingsValidTimeZoneInfosResponses, ShiftApplicationsApplyForShiftData, ShiftApplicationsApplyForShiftResponses, ShiftApplicationsGet2Data, ShiftApplicationsGet2Responses, ShiftApplicationsGetData, ShiftApplicationsGetResponses, ShiftApplicationsRevokeShiftApplicationData, ShiftApplicationsRevokeShiftApplicationResponses, ShiftsCancelData, ShiftsCancelResponses, ShiftsCommitShiftData, ShiftsCommitShiftResponses, ShiftsDeleteData, ShiftsDeleteResponses, ShiftsFinalizeShiftData, ShiftsFinalizeShiftResponses, ShiftsFreezeShiftData, ShiftsFreezeShiftResponses, ShiftsFreezeShiftsData, ShiftsFreezeShiftsResponses, ShiftsGet2Data, ShiftsGet2Responses, ShiftsGetApplicationEventsData, ShiftsGetApplicationEventsResponses, ShiftsGetData, ShiftsGetIssuesAllData, ShiftsGetIssuesAllResponses, ShiftsGetIssuesData, ShiftsGetIssuesResponses, ShiftsGetResponses, ShiftsGetShiftsForCalendarWeekData, ShiftsGetShiftsForCalendarWeekResponses, ShiftsGetShiftsForDateData, ShiftsGetShiftsForDateResponses, ShiftsGetShiftsWithoutTeamLeaderData, ShiftsGetShiftsWithoutTeamLeaderResponses, ShiftsPostData, ShiftsPostResponses, ShiftsPutData, ShiftsPutResponses, ShiftsReleaseShiftData, ShiftsReleaseShiftResponses, ShiftsScaffoldData, ShiftsScaffoldResponses, ShiftsThawShiftData, ShiftsThawShiftResponses, ShiftsUnreleaseShiftData, ShiftsUnreleaseShiftResponses, SubscriptionsGetNotificationTypesData, SubscriptionsGetNotificationTypesResponses, SubscriptionsGetSubscriptionData, SubscriptionsGetSubscriptionResponses, SubscriptionsGetSubscriptionsData, SubscriptionsGetSubscriptionsResponses, SubscriptionsUpdateSubscriptionData, SubscriptionsUpdateSubscriptionResponses, SubscriptionsUpdateSubscriptionsData, SubscriptionsUpdateSubscriptionsResponses, TurnReportsCreateTurnReportData, TurnReportsCreateTurnReportResponses, TurnReportsGet2Data, TurnReportsGet2Responses, TurnReportsGetData, TurnReportsGetMissingReportsData, TurnReportsGetMissingReportsResponses, TurnReportsGetResponses, TurnReportsPutData, TurnReportsPutResponses, TurnsAssignData, TurnsAssignmentCandidatesData, TurnsAssignmentCandidatesResponses, TurnsAssignResponses, TurnsCancelData, TurnsCancelResponses, TurnsEnableData, TurnsEnableResponses, TurnsGet2Data, TurnsGet2Responses, TurnsGetData, TurnsGetIssuesData, TurnsGetIssuesResponses, TurnsGetOtherTeamLeadersData, TurnsGetOtherTeamLeadersResponses, TurnsGetPrecedingAndFollowingTeamsData, TurnsGetPrecedingAndFollowingTeamsResponses, TurnsGetResponses, TurnsRevertData, TurnsRevertResponses, TurnsSetRequiredParticipantsData, TurnsSetRequiredParticipantsResponses, TurnsTurnsOpenForExperiencesData, TurnsTurnsOpenForExperiencesResponses, UpdateCircuitData, UpdateCircuitErrors, UpdateCircuitResponses, UpdateCongregationData, UpdateCongregationErrors, UpdateCongregationResponses, UpdateDepotData, UpdateDepotErrors, UpdateDepotResponses, UpdateMessagingSettingsData, UpdateMessagingSettingsErrors, UpdateMessagingSettingsResponses, UpdateProjectData, UpdateProjectErrors, UpdateProjectResponses, UpdatePublisherData, UpdatePublisherEmergencyStatusData, UpdatePublisherEmergencyStatusErrors, UpdatePublisherEmergencyStatusResponses, UpdatePublisherErrors, UpdatePublisherProfileData, UpdatePublisherProfileErrors, UpdatePublisherProfileResponses, UpdatePublisherResponses, UpdateRouteData, UpdateRouteErrors, UpdateRouteResponses, UpdateTenantData, UpdateTenantResponses, UploadDocumentData, UploadDocumentErrors, UploadDocumentResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const fetchTenants = <ThrowOnError extends boolean = false>(options?: Options<FetchTenantsData, ThrowOnError>): RequestResult<FetchTenantsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<FetchTenantsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/tenants',
    ...options
});

export const createTenant = <ThrowOnError extends boolean = false>(options: Options<CreateTenantData, ThrowOnError>): RequestResult<CreateTenantResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateTenantResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/tenants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteTenant = <ThrowOnError extends boolean = false>(options: Options<DeleteTenantData, ThrowOnError>): RequestResult<DeleteTenantResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteTenantResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/tenants/{id}',
    ...options
});

export const fetchTenant = <ThrowOnError extends boolean = false>(options: Options<FetchTenantData, ThrowOnError>): RequestResult<FetchTenantResponses, unknown, ThrowOnError> => (options.client ?? client).get<FetchTenantResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/tenants/{id}',
    ...options
});

export const updateTenant = <ThrowOnError extends boolean = false>(options: Options<UpdateTenantData, ThrowOnError>): RequestResult<UpdateTenantResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateTenantResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/tenants/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getUserInfo = <ThrowOnError extends boolean = false>(options?: Options<GetUserInfoData, ThrowOnError>): RequestResult<GetUserInfoResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUserInfoResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/user-info',
    ...options
});

export const getDocs = <ThrowOnError extends boolean = false>(options: Options<GetDocsData, ThrowOnError>): RequestResult<GetDocsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetDocsResponses, unknown, ThrowOnError>({ url: '/docs/{shortDocumentId}', ...options });

export const fetchAuditEvents = <ThrowOnError extends boolean = false>(options: Options<FetchAuditEventsData, ThrowOnError>): RequestResult<FetchAuditEventsResponses, FetchAuditEventsErrors, ThrowOnError> => (options.client ?? client).get<FetchAuditEventsResponses, FetchAuditEventsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/audit/events',
    ...options
});

export const leaveEmergencyMode = <ThrowOnError extends boolean = false>(options?: Options<LeaveEmergencyModeData, ThrowOnError>): RequestResult<LeaveEmergencyModeResponses, LeaveEmergencyModeErrors, ThrowOnError> => (options?.client ?? client).delete<LeaveEmergencyModeResponses, LeaveEmergencyModeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/emergency-mode/current-emergency',
    ...options
});

export const fetchCurrentEmergency = <ThrowOnError extends boolean = false>(options?: Options<FetchCurrentEmergencyData, ThrowOnError>): RequestResult<FetchCurrentEmergencyResponses, FetchCurrentEmergencyErrors, ThrowOnError> => (options?.client ?? client).get<FetchCurrentEmergencyResponses, FetchCurrentEmergencyErrors, ThrowOnError>({
    responseType: 'json',
    url: '/emergency-mode/current-emergency',
    ...options
});

export const enterEmergencyMode = <ThrowOnError extends boolean = false>(options: Options<EnterEmergencyModeData, ThrowOnError>): RequestResult<EnterEmergencyModeResponses, EnterEmergencyModeErrors, ThrowOnError> => (options.client ?? client).post<EnterEmergencyModeResponses, EnterEmergencyModeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/emergency-mode/current-emergency',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchCurrentEmergencyState = <ThrowOnError extends boolean = false>(options?: Options<FetchCurrentEmergencyStateData, ThrowOnError>): RequestResult<FetchCurrentEmergencyStateResponses, FetchCurrentEmergencyStateErrors, ThrowOnError> => (options?.client ?? client).get<FetchCurrentEmergencyStateResponses, FetchCurrentEmergencyStateErrors, ThrowOnError>({
    responseType: 'json',
    url: '/emergency-mode/current-emergency/state',
    ...options
});

export const updatePublisherEmergencyStatus = <ThrowOnError extends boolean = false>(options: Options<UpdatePublisherEmergencyStatusData, ThrowOnError>): RequestResult<UpdatePublisherEmergencyStatusResponses, UpdatePublisherEmergencyStatusErrors, ThrowOnError> => (options.client ?? client).put<UpdatePublisherEmergencyStatusResponses, UpdatePublisherEmergencyStatusErrors, ThrowOnError>({
    responseType: 'json',
    url: '/emergency-mode/current-emergency/state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchPublisherEmergencyReportByPublisherId = <ThrowOnError extends boolean = false>(options: Options<FetchPublisherEmergencyReportByPublisherIdData, ThrowOnError>): RequestResult<FetchPublisherEmergencyReportByPublisherIdResponses, FetchPublisherEmergencyReportByPublisherIdErrors, ThrowOnError> => (options.client ?? client).get<FetchPublisherEmergencyReportByPublisherIdResponses, FetchPublisherEmergencyReportByPublisherIdErrors, ThrowOnError>({
    responseType: 'json',
    url: '/emergency-mode/current-emergency/state/of-publisher/{publisherId}',
    ...options
});

export const acknowledgeEmergencyViaWebUi = <ThrowOnError extends boolean = false>(options: Options<AcknowledgeEmergencyViaWebUiData, ThrowOnError>): RequestResult<AcknowledgeEmergencyViaWebUiResponses, AcknowledgeEmergencyViaWebUiErrors, ThrowOnError> => (options.client ?? client).post<AcknowledgeEmergencyViaWebUiResponses, AcknowledgeEmergencyViaWebUiErrors, ThrowOnError>({
    responseType: 'json',
    url: '/emergency-mode/current-emergency/{publisherId}/acknowledge',
    ...options
});

export const reportAsSafeViaWebUi = <ThrowOnError extends boolean = false>(options: Options<ReportAsSafeViaWebUiData, ThrowOnError>): RequestResult<ReportAsSafeViaWebUiResponses, ReportAsSafeViaWebUiErrors, ThrowOnError> => (options.client ?? client).post<ReportAsSafeViaWebUiResponses, ReportAsSafeViaWebUiErrors, ThrowOnError>({
    responseType: 'json',
    url: '/emergency-mode/current-emergency/{publisherId}/report-as-safe',
    ...options
});

export const fetchDepots = <ThrowOnError extends boolean = false>(options: Options<FetchDepotsData, ThrowOnError>): RequestResult<FetchDepotsResponses, FetchDepotsErrors, ThrowOnError> => (options.client ?? client).get<FetchDepotsResponses, FetchDepotsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/depots',
    ...options
});

export const createDepot = <ThrowOnError extends boolean = false>(options: Options<CreateDepotData, ThrowOnError>): RequestResult<CreateDepotResponses, CreateDepotErrors, ThrowOnError> => (options.client ?? client).post<CreateDepotResponses, CreateDepotErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/depots',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateDepot = <ThrowOnError extends boolean = false>(options: Options<UpdateDepotData, ThrowOnError>): RequestResult<UpdateDepotResponses, UpdateDepotErrors, ThrowOnError> => (options.client ?? client).put<UpdateDepotResponses, UpdateDepotErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/depots',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteDepot = <ThrowOnError extends boolean = false>(options: Options<DeleteDepotData, ThrowOnError>): RequestResult<DeleteDepotResponses, DeleteDepotErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDepotResponses, DeleteDepotErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/depots/{id}',
    ...options
});

export const fetchDepot = <ThrowOnError extends boolean = false>(options: Options<FetchDepotData, ThrowOnError>): RequestResult<FetchDepotResponses, FetchDepotErrors, ThrowOnError> => (options.client ?? client).get<FetchDepotResponses, FetchDepotErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/depots/{id}',
    ...options
});

export const mergeDepots = <ThrowOnError extends boolean = false>(options: Options<MergeDepotsData, ThrowOnError>): RequestResult<MergeDepotsResponses, MergeDepotsErrors, ThrowOnError> => (options.client ?? client).post<MergeDepotsResponses, MergeDepotsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/depots/merger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchRoutes = <ThrowOnError extends boolean = false>(options: Options<FetchRoutesData, ThrowOnError>): RequestResult<FetchRoutesResponses, FetchRoutesErrors, ThrowOnError> => (options.client ?? client).get<FetchRoutesResponses, FetchRoutesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes',
    ...options
});

export const createRoute = <ThrowOnError extends boolean = false>(options: Options<CreateRouteData, ThrowOnError>): RequestResult<CreateRouteResponses, CreateRouteErrors, ThrowOnError> => (options.client ?? client).post<CreateRouteResponses, CreateRouteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateRoute = <ThrowOnError extends boolean = false>(options: Options<UpdateRouteData, ThrowOnError>): RequestResult<UpdateRouteResponses, UpdateRouteErrors, ThrowOnError> => (options.client ?? client).put<UpdateRouteResponses, UpdateRouteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteRoute = <ThrowOnError extends boolean = false>(options: Options<DeleteRouteData, ThrowOnError>): RequestResult<DeleteRouteResponses, DeleteRouteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRouteResponses, DeleteRouteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes/{id}',
    ...options
});

export const fetchRoute = <ThrowOnError extends boolean = false>(options: Options<FetchRouteData, ThrowOnError>): RequestResult<FetchRouteResponses, FetchRouteErrors, ThrowOnError> => (options.client ?? client).get<FetchRouteResponses, FetchRouteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes/{id}',
    ...options
});

export const activateRoute = <ThrowOnError extends boolean = false>(options: Options<ActivateRouteData, ThrowOnError>): RequestResult<ActivateRouteResponses, ActivateRouteErrors, ThrowOnError> => (options.client ?? client).post<ActivateRouteResponses, ActivateRouteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes/{id}/activation',
    ...options
});

export const deactivateRoute = <ThrowOnError extends boolean = false>(options: Options<DeactivateRouteData, ThrowOnError>): RequestResult<DeactivateRouteResponses, DeactivateRouteErrors, ThrowOnError> => (options.client ?? client).post<DeactivateRouteResponses, DeactivateRouteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes/{id}/deactivation',
    ...options
});

export const deleteRouteSchedule = <ThrowOnError extends boolean = false>(options: Options<DeleteRouteScheduleData, ThrowOnError>): RequestResult<DeleteRouteScheduleResponses, DeleteRouteScheduleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRouteScheduleResponses, DeleteRouteScheduleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes/{routeId}/schedule',
    ...options
});

export const fetchRouteSchedule = <ThrowOnError extends boolean = false>(options: Options<FetchRouteScheduleData, ThrowOnError>): RequestResult<FetchRouteScheduleResponses, FetchRouteScheduleErrors, ThrowOnError> => (options.client ?? client).get<FetchRouteScheduleResponses, FetchRouteScheduleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes/{routeId}/schedule',
    ...options
});

export const saveRouteSchedule = <ThrowOnError extends boolean = false>(options: Options<SaveRouteScheduleData, ThrowOnError>): RequestResult<SaveRouteScheduleResponses, SaveRouteScheduleErrors, ThrowOnError> => (options.client ?? client).post<SaveRouteScheduleResponses, SaveRouteScheduleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes/schedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const isRouteOpenForShift = <ThrowOnError extends boolean = false>(options: Options<IsRouteOpenForShiftData, ThrowOnError>): RequestResult<IsRouteOpenForShiftResponses, IsRouteOpenForShiftErrors, ThrowOnError> => (options.client ?? client).post<IsRouteOpenForShiftResponses, IsRouteOpenForShiftErrors, ThrowOnError>({
    responseType: 'json',
    url: '/logistics/routes/is-open',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchMessagingSettings = <ThrowOnError extends boolean = false>(options?: Options<FetchMessagingSettingsData, ThrowOnError>): RequestResult<FetchMessagingSettingsResponses, FetchMessagingSettingsErrors, ThrowOnError> => (options?.client ?? client).get<FetchMessagingSettingsResponses, FetchMessagingSettingsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/messaging/settings',
    ...options
});

export const updateMessagingSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateMessagingSettingsData, ThrowOnError>): RequestResult<UpdateMessagingSettingsResponses, UpdateMessagingSettingsErrors, ThrowOnError> => (options.client ?? client).post<UpdateMessagingSettingsResponses, UpdateMessagingSettingsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/messaging/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const sendTestEmail = <ThrowOnError extends boolean = false>(options: Options<SendTestEmailData, ThrowOnError>): RequestResult<SendTestEmailResponses, SendTestEmailErrors, ThrowOnError> => (options.client ?? client).post<SendTestEmailResponses, SendTestEmailErrors, ThrowOnError>({
    responseType: 'json',
    url: '/messaging/tests/email/{emailAddress}',
    ...options
});

export const sendTestSms = <ThrowOnError extends boolean = false>(options: Options<SendTestSmsData, ThrowOnError>): RequestResult<SendTestSmsResponses, SendTestSmsErrors, ThrowOnError> => (options.client ?? client).post<SendTestSmsResponses, SendTestSmsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/messaging/tests/sms/{phoneNumber}',
    ...options
});

export const fetchProjectCalendarMonth = <ThrowOnError extends boolean = false>(options: Options<FetchProjectCalendarMonthData, ThrowOnError>): RequestResult<FetchProjectCalendarMonthResponses, FetchProjectCalendarMonthErrors, ThrowOnError> => (options.client ?? client).get<FetchProjectCalendarMonthResponses, FetchProjectCalendarMonthErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/calendar/{year}/month/{month}',
    ...options
});

export const fetchProjectCalendarWeek = <ThrowOnError extends boolean = false>(options: Options<FetchProjectCalendarWeekData, ThrowOnError>): RequestResult<FetchProjectCalendarWeekResponses, FetchProjectCalendarWeekErrors, ThrowOnError> => (options.client ?? client).get<FetchProjectCalendarWeekResponses, FetchProjectCalendarWeekErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/calendar/{year}/week/{calendarWeek}',
    ...options
});

export const addCalendarEvent = <ThrowOnError extends boolean = false>(options: Options<AddCalendarEventData, ThrowOnError>): RequestResult<AddCalendarEventResponses, AddCalendarEventErrors, ThrowOnError> => (options.client ?? client).post<AddCalendarEventResponses, AddCalendarEventErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/calendar',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const importHolidays = <ThrowOnError extends boolean = false>(options?: Options<ImportHolidaysData, ThrowOnError>): RequestResult<ImportHolidaysResponses, ImportHolidaysErrors, ThrowOnError> => (options?.client ?? client).post<ImportHolidaysResponses, ImportHolidaysErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/projects/calendar/import/holidays',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

export const deleteCalendarEvent = <ThrowOnError extends boolean = false>(options: Options<DeleteCalendarEventData, ThrowOnError>): RequestResult<DeleteCalendarEventResponses, DeleteCalendarEventErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCalendarEventResponses, DeleteCalendarEventErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/calendar/{id}',
    ...options
});

export const createFolder = <ThrowOnError extends boolean = false>(options: Options<CreateFolderData, ThrowOnError>): RequestResult<CreateFolderResponses, CreateFolderErrors, ThrowOnError> => (options.client ?? client).post<CreateFolderResponses, CreateFolderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/documents/folders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchFolderContent = <ThrowOnError extends boolean = false>(options: Options<FetchFolderContentData, ThrowOnError>): RequestResult<FetchFolderContentResponses, FetchFolderContentErrors, ThrowOnError> => (options.client ?? client).get<FetchFolderContentResponses, FetchFolderContentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/documents/folders/{folderId}/content',
    ...options
});

export const renameFolder = <ThrowOnError extends boolean = false>(options: Options<RenameFolderData, ThrowOnError>): RequestResult<RenameFolderResponses, RenameFolderErrors, ThrowOnError> => (options.client ?? client).put<RenameFolderResponses, RenameFolderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/documents/folders/{folderId}/name/{folderName}',
    ...options
});

export const moveFolder = <ThrowOnError extends boolean = false>(options: Options<MoveFolderData, ThrowOnError>): RequestResult<MoveFolderResponses, MoveFolderErrors, ThrowOnError> => (options.client ?? client).put<MoveFolderResponses, MoveFolderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/documents/folders/{folderId}/parent-folder-id/{parentFolderId}',
    ...options
});

export const repurposeFolder = <ThrowOnError extends boolean = false>(options: Options<RepurposeFolderData, ThrowOnError>): RequestResult<RepurposeFolderResponses, RepurposeFolderErrors, ThrowOnError> => (options.client ?? client).put<RepurposeFolderResponses, RepurposeFolderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/documents/folders/{folderId}/purpose/{folderPurpose}',
    ...options
});

export const deleteFolder = <ThrowOnError extends boolean = false>(options: Options<DeleteFolderData, ThrowOnError>): RequestResult<DeleteFolderResponses, DeleteFolderErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFolderResponses, DeleteFolderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/documents/folders/{folderId}',
    ...options
});

export const uploadDocument = <ThrowOnError extends boolean = false>(options: Options<UploadDocumentData, ThrowOnError>): RequestResult<UploadDocumentResponses, UploadDocumentErrors, ThrowOnError> => (options.client ?? client).post<UploadDocumentResponses, UploadDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/projects/documents/folders/{folderId}/documents',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const renameDocument = <ThrowOnError extends boolean = false>(options: Options<RenameDocumentData, ThrowOnError>): RequestResult<RenameDocumentResponses, RenameDocumentErrors, ThrowOnError> => (options.client ?? client).put<RenameDocumentResponses, RenameDocumentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/documents/documents/{documentId}/name',
    ...options
});

export const deleteDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteDocumentData, ThrowOnError>): RequestResult<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDocumentResponses, DeleteDocumentErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/documents/documents/{documentId}',
    ...options
});

export const downloadDocument = <ThrowOnError extends boolean = false>(options: Options<DownloadDocumentData, ThrowOnError>): RequestResult<unknown, DownloadDocumentErrors, ThrowOnError> => (options.client ?? client).get<unknown, DownloadDocumentErrors, ThrowOnError>({ url: '/projects/documents/{documentId}', ...options });

export const fetchFeatureFlags = <ThrowOnError extends boolean = false>(options?: Options<FetchFeatureFlagsData, ThrowOnError>): RequestResult<FetchFeatureFlagsResponses, FetchFeatureFlagsErrors, ThrowOnError> => (options?.client ?? client).get<FetchFeatureFlagsResponses, FetchFeatureFlagsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/feature-flags',
    ...options
});

export const enableFeature = <ThrowOnError extends boolean = false>(options: Options<EnableFeatureData, ThrowOnError>): RequestResult<EnableFeatureResponses, EnableFeatureErrors, ThrowOnError> => (options.client ?? client).post<EnableFeatureResponses, EnableFeatureErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/feature-flags/{feature}/enable',
    ...options
});

export const disableFeature = <ThrowOnError extends boolean = false>(options: Options<DisableFeatureData, ThrowOnError>): RequestResult<DisableFeatureResponses, DisableFeatureErrors, ThrowOnError> => (options.client ?? client).post<DisableFeatureResponses, DisableFeatureErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/feature-flags/{feature}/disable',
    ...options
});

export const fetchProject = <ThrowOnError extends boolean = false>(options?: Options<FetchProjectData, ThrowOnError>): RequestResult<FetchProjectResponses, FetchProjectErrors, ThrowOnError> => (options?.client ?? client).get<FetchProjectResponses, FetchProjectErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/project',
    ...options
});

export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> => (options.client ?? client).put<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/project',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchProjectName = <ThrowOnError extends boolean = false>(options?: Options<FetchProjectNameData, ThrowOnError>): RequestResult<FetchProjectNameResponses, FetchProjectNameErrors, ThrowOnError> => (options?.client ?? client).get<FetchProjectNameResponses, FetchProjectNameErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/project/name',
    ...options
});

export const fetchContactInfo = <ThrowOnError extends boolean = false>(options?: Options<FetchContactInfoData, ThrowOnError>): RequestResult<FetchContactInfoResponses, FetchContactInfoErrors, ThrowOnError> => (options?.client ?? client).get<FetchContactInfoResponses, FetchContactInfoErrors, ThrowOnError>({
    responseType: 'json',
    url: '/projects/project/contact-info',
    ...options
});

export const fetchCircuits = <ThrowOnError extends boolean = false>(options: Options<FetchCircuitsData, ThrowOnError>): RequestResult<FetchCircuitsResponses, FetchCircuitsErrors, ThrowOnError> => (options.client ?? client).get<FetchCircuitsResponses, FetchCircuitsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/circuits',
    ...options
});

export const createCircuit = <ThrowOnError extends boolean = false>(options: Options<CreateCircuitData, ThrowOnError>): RequestResult<CreateCircuitResponses, CreateCircuitErrors, ThrowOnError> => (options.client ?? client).post<CreateCircuitResponses, CreateCircuitErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/circuits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateCircuit = <ThrowOnError extends boolean = false>(options: Options<UpdateCircuitData, ThrowOnError>): RequestResult<UpdateCircuitResponses, UpdateCircuitErrors, ThrowOnError> => (options.client ?? client).put<UpdateCircuitResponses, UpdateCircuitErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/circuits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteCircuit = <ThrowOnError extends boolean = false>(options: Options<DeleteCircuitData, ThrowOnError>): RequestResult<DeleteCircuitResponses, DeleteCircuitErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCircuitResponses, DeleteCircuitErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/circuits/{id}',
    ...options
});

export const fetchCircuit = <ThrowOnError extends boolean = false>(options: Options<FetchCircuitData, ThrowOnError>): RequestResult<FetchCircuitResponses, FetchCircuitErrors, ThrowOnError> => (options.client ?? client).get<FetchCircuitResponses, FetchCircuitErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/circuits/{id}',
    ...options
});

export const mergeCircuits = <ThrowOnError extends boolean = false>(options: Options<MergeCircuitsData, ThrowOnError>): RequestResult<MergeCircuitsResponses, MergeCircuitsErrors, ThrowOnError> => (options.client ?? client).post<MergeCircuitsResponses, MergeCircuitsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/circuits/merger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchCongregations = <ThrowOnError extends boolean = false>(options: Options<FetchCongregationsData, ThrowOnError>): RequestResult<FetchCongregationsResponses, FetchCongregationsErrors, ThrowOnError> => (options.client ?? client).get<FetchCongregationsResponses, FetchCongregationsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/congregations',
    ...options
});

export const createCongregation = <ThrowOnError extends boolean = false>(options: Options<CreateCongregationData, ThrowOnError>): RequestResult<CreateCongregationResponses, CreateCongregationErrors, ThrowOnError> => (options.client ?? client).post<CreateCongregationResponses, CreateCongregationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/congregations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateCongregation = <ThrowOnError extends boolean = false>(options: Options<UpdateCongregationData, ThrowOnError>): RequestResult<UpdateCongregationResponses, UpdateCongregationErrors, ThrowOnError> => (options.client ?? client).put<UpdateCongregationResponses, UpdateCongregationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/congregations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteCongregation = <ThrowOnError extends boolean = false>(options: Options<DeleteCongregationData, ThrowOnError>): RequestResult<DeleteCongregationResponses, DeleteCongregationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCongregationResponses, DeleteCongregationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/congregations/{id}',
    ...options
});

export const fetchCongregation = <ThrowOnError extends boolean = false>(options: Options<FetchCongregationData, ThrowOnError>): RequestResult<FetchCongregationResponses, FetchCongregationErrors, ThrowOnError> => (options.client ?? client).get<FetchCongregationResponses, FetchCongregationErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/congregations/{id}',
    ...options
});

export const mergeCongregations = <ThrowOnError extends boolean = false>(options: Options<MergeCongregationsData, ThrowOnError>): RequestResult<MergeCongregationsResponses, MergeCongregationsErrors, ThrowOnError> => (options.client ?? client).post<MergeCongregationsResponses, MergeCongregationsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/congregations/merger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchPublishers = <ThrowOnError extends boolean = false>(options: Options<FetchPublishersData, ThrowOnError>): RequestResult<FetchPublishersResponses, FetchPublishersErrors, ThrowOnError> => (options.client ?? client).get<FetchPublishersResponses, FetchPublishersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/publishers',
    ...options
});

export const createPublisher = <ThrowOnError extends boolean = false>(options: Options<CreatePublisherData, ThrowOnError>): RequestResult<CreatePublisherResponses, CreatePublisherErrors, ThrowOnError> => (options.client ?? client).post<CreatePublisherResponses, CreatePublisherErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/publishers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updatePublisher = <ThrowOnError extends boolean = false>(options: Options<UpdatePublisherData, ThrowOnError>): RequestResult<UpdatePublisherResponses, UpdatePublisherErrors, ThrowOnError> => (options.client ?? client).put<UpdatePublisherResponses, UpdatePublisherErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/publishers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deletePublisher = <ThrowOnError extends boolean = false>(options: Options<DeletePublisherData, ThrowOnError>): RequestResult<DeletePublisherResponses, DeletePublisherErrors, ThrowOnError> => (options.client ?? client).delete<DeletePublisherResponses, DeletePublisherErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/publishers/{id}',
    ...options
});

export const fetchPublisher = <ThrowOnError extends boolean = false>(options: Options<FetchPublisherData, ThrowOnError>): RequestResult<FetchPublisherResponses, FetchPublisherErrors, ThrowOnError> => (options.client ?? client).get<FetchPublisherResponses, FetchPublisherErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/publishers/{id}',
    ...options
});

export const exportPublishersToExcel = <ThrowOnError extends boolean = false>(options?: Options<ExportPublishersToExcelData, ThrowOnError>): RequestResult<unknown, ExportPublishersToExcelErrors, ThrowOnError> => (options?.client ?? client).get<unknown, ExportPublishersToExcelErrors, ThrowOnError>({ url: '/participants/publishers/export/xlsx', ...options });

export const exportPublishersToVCard = <ThrowOnError extends boolean = false>(options?: Options<ExportPublishersToVCardData, ThrowOnError>): RequestResult<ExportPublishersToVCardResponses, ExportPublishersToVCardErrors, ThrowOnError> => (options?.client ?? client).get<ExportPublishersToVCardResponses, ExportPublishersToVCardErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/publishers/export/vcf',
    ...options
});

export const activatePublisher = <ThrowOnError extends boolean = false>(options: Options<ActivatePublisherData, ThrowOnError>): RequestResult<ActivatePublisherResponses, ActivatePublisherErrors, ThrowOnError> => (options.client ?? client).post<ActivatePublisherResponses, ActivatePublisherErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/publishers/activation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deactivatePublisher = <ThrowOnError extends boolean = false>(options: Options<DeactivatePublisherData, ThrowOnError>): RequestResult<DeactivatePublisherResponses, DeactivatePublisherErrors, ThrowOnError> => (options.client ?? client).post<DeactivatePublisherResponses, DeactivatePublisherErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/publishers/deactivation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const importPublishersFromExcel = <ThrowOnError extends boolean = false>(options: Options<ImportPublishersFromExcelData, ThrowOnError>): RequestResult<ImportPublishersFromExcelResponses, ImportPublishersFromExcelErrors, ThrowOnError> => (options.client ?? client).post<ImportPublishersFromExcelResponses, ImportPublishersFromExcelErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/participants/publishers/import/xlsx',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const getPublisherImportTemplate = <ThrowOnError extends boolean = false>(options?: Options<GetPublisherImportTemplateData, ThrowOnError>): RequestResult<unknown, GetPublisherImportTemplateErrors, ThrowOnError> => (options?.client ?? client).get<unknown, GetPublisherImportTemplateErrors, ThrowOnError>({ url: '/participants/publishers/import/xlsx/template', ...options });

export const fetchPublisherProfile = <ThrowOnError extends boolean = false>(options: Options<FetchPublisherProfileData, ThrowOnError>): RequestResult<FetchPublisherProfileResponses, FetchPublisherProfileErrors, ThrowOnError> => (options.client ?? client).get<FetchPublisherProfileResponses, FetchPublisherProfileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/publisher-profiles/{id}',
    ...options
});

export const updatePublisherProfile = <ThrowOnError extends boolean = false>(options: Options<UpdatePublisherProfileData, ThrowOnError>): RequestResult<UpdatePublisherProfileResponses, UpdatePublisherProfileErrors, ThrowOnError> => (options.client ?? client).put<UpdatePublisherProfileResponses, UpdatePublisherProfileErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participants/publisher-profiles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchSettings = <ThrowOnError extends boolean = false>(options?: Options<FetchSettingsData, ThrowOnError>): RequestResult<FetchSettingsResponses, FetchSettingsErrors, ThrowOnError> => (options?.client ?? client).get<FetchSettingsResponses, FetchSettingsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participation/settings',
    ...options
});

export const allowPublishersToMaintainRoutePreferences = <ThrowOnError extends boolean = false>(options: Options<AllowPublishersToMaintainRoutePreferencesData, ThrowOnError>): RequestResult<AllowPublishersToMaintainRoutePreferencesResponses, AllowPublishersToMaintainRoutePreferencesErrors, ThrowOnError> => (options.client ?? client).post<AllowPublishersToMaintainRoutePreferencesResponses, AllowPublishersToMaintainRoutePreferencesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participation/settings/allow-publishers-to-maintain-route-preferences/{enabled}',
    ...options
});

export const fetchParticipantPreferences = <ThrowOnError extends boolean = false>(options: Options<FetchParticipantPreferencesData, ThrowOnError>): RequestResult<FetchParticipantPreferencesResponses, FetchParticipantPreferencesErrors, ThrowOnError> => (options.client ?? client).get<FetchParticipantPreferencesResponses, FetchParticipantPreferencesErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participation/route-preferences/{participantId}',
    ...options
});

export const makeRoutePreferred = <ThrowOnError extends boolean = false>(options: Options<MakeRoutePreferredData, ThrowOnError>): RequestResult<MakeRoutePreferredResponses, MakeRoutePreferredErrors, ThrowOnError> => (options.client ?? client).put<MakeRoutePreferredResponses, MakeRoutePreferredErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participation/route-preferences/{participantId}/prefer-route/{routeId}',
    ...options
});

export const makeRouteDisfavored = <ThrowOnError extends boolean = false>(options: Options<MakeRouteDisfavoredData, ThrowOnError>): RequestResult<MakeRouteDisfavoredResponses, MakeRouteDisfavoredErrors, ThrowOnError> => (options.client ?? client).put<MakeRouteDisfavoredResponses, MakeRouteDisfavoredErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participation/route-preferences/{participantId}/disfavor-route/{routeId}',
    ...options
});

export const deleteParticipantRoutePreference = <ThrowOnError extends boolean = false>(options: Options<DeleteParticipantRoutePreferenceData, ThrowOnError>): RequestResult<DeleteParticipantRoutePreferenceResponses, DeleteParticipantRoutePreferenceErrors, ThrowOnError> => (options.client ?? client).delete<DeleteParticipantRoutePreferenceResponses, DeleteParticipantRoutePreferenceErrors, ThrowOnError>({
    responseType: 'json',
    url: '/participation/route-preferences/{participantId}/on-route/{routeId}',
    ...options
});

export const getE2eTestTimeNow = <ThrowOnError extends boolean = false>(options?: Options<GetE2eTestTimeNowData, ThrowOnError>): RequestResult<GetE2eTestTimeNowResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetE2eTestTimeNowResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/e2e/test-time/now',
    ...options
});

export const postE2eTestTimeNow = <ThrowOnError extends boolean = false>(options: Options<PostE2eTestTimeNowData, ThrowOnError>): RequestResult<PostE2eTestTimeNowResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostE2eTestTimeNowResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/e2e/test-time/now',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postE2eTestTimeReset = <ThrowOnError extends boolean = false>(options?: Options<PostE2eTestTimeResetData, ThrowOnError>): RequestResult<PostE2eTestTimeResetResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostE2eTestTimeResetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/e2e/test-time/reset',
    ...options
});

export const postE2eTenantSeed = <ThrowOnError extends boolean = false>(options: Options<PostE2eTenantSeedData, ThrowOnError>): RequestResult<PostE2eTenantSeedResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostE2eTenantSeedResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/e2e/tenant/seed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const turnsAssignmentCandidates = <ThrowOnError extends boolean = false>(options: Options<TurnsAssignmentCandidatesData, ThrowOnError>): RequestResult<TurnsAssignmentCandidatesResponses, unknown, ThrowOnError> => (options.client ?? client).get<TurnsAssignmentCandidatesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Turns/{id}/Candidates',
    ...options
});

export const turnsGetIssues = <ThrowOnError extends boolean = false>(options: Options<TurnsGetIssuesData, ThrowOnError>): RequestResult<TurnsGetIssuesResponses, unknown, ThrowOnError> => (options.client ?? client).get<TurnsGetIssuesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Turns/{id}/Issues',
    ...options
});

export const turnsTurnsOpenForExperiences = <ThrowOnError extends boolean = false>(options?: Options<TurnsTurnsOpenForExperiencesData, ThrowOnError>): RequestResult<TurnsTurnsOpenForExperiencesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TurnsTurnsOpenForExperiencesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Turns/openForExperiences',
    ...options
});

export const turnsEnable = <ThrowOnError extends boolean = false>(options: Options<TurnsEnableData, ThrowOnError>): RequestResult<TurnsEnableResponses, unknown, ThrowOnError> => (options.client ?? client).post<TurnsEnableResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Turns/{id}/Enabling',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const turnsAssign = <ThrowOnError extends boolean = false>(options: Options<TurnsAssignData, ThrowOnError>): RequestResult<TurnsAssignResponses, unknown, ThrowOnError> => (options.client ?? client).post<TurnsAssignResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Turns/{id}/Assignment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const turnsRevert = <ThrowOnError extends boolean = false>(options: Options<TurnsRevertData, ThrowOnError>): RequestResult<TurnsRevertResponses, unknown, ThrowOnError> => (options.client ?? client).post<TurnsRevertResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Turns/{id}/Revert',
    ...options
});

export const turnsSetRequiredParticipants = <ThrowOnError extends boolean = false>(options: Options<TurnsSetRequiredParticipantsData, ThrowOnError>): RequestResult<TurnsSetRequiredParticipantsResponses, unknown, ThrowOnError> => (options.client ?? client).put<TurnsSetRequiredParticipantsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Turns/{id}/RequiredParticipants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const turnsCancel = <ThrowOnError extends boolean = false>(options: Options<TurnsCancelData, ThrowOnError>): RequestResult<TurnsCancelResponses, unknown, ThrowOnError> => (options.client ?? client).post<TurnsCancelResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Turns/{id}/Cancellation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const turnsGetOtherTeamLeaders = <ThrowOnError extends boolean = false>(options: Options<TurnsGetOtherTeamLeadersData, ThrowOnError>): RequestResult<TurnsGetOtherTeamLeadersResponses, unknown, ThrowOnError> => (options.client ?? client).get<TurnsGetOtherTeamLeadersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Turns/{id}/OtherTeamLeaders',
    ...options
});

export const turnsGetPrecedingAndFollowingTeams = <ThrowOnError extends boolean = false>(options: Options<TurnsGetPrecedingAndFollowingTeamsData, ThrowOnError>): RequestResult<TurnsGetPrecedingAndFollowingTeamsResponses, unknown, ThrowOnError> => (options.client ?? client).get<TurnsGetPrecedingAndFollowingTeamsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Turns/{turnId}/PrecedingAndFollowingTeams',
    ...options
});

export const turnsGet = <ThrowOnError extends boolean = false>(options?: Options<TurnsGetData, ThrowOnError>): RequestResult<TurnsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TurnsGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Turns',
    ...options
});

export const turnsGet2 = <ThrowOnError extends boolean = false>(options: Options<TurnsGet2Data, ThrowOnError>): RequestResult<TurnsGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<TurnsGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Turns/{id}',
    ...options
});

export const turnReportsGet = <ThrowOnError extends boolean = false>(options?: Options<TurnReportsGetData, ThrowOnError>): RequestResult<TurnReportsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TurnReportsGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/TurnReports',
    ...options
});

export const turnReportsCreateTurnReport = <ThrowOnError extends boolean = false>(options: Options<TurnReportsCreateTurnReportData, ThrowOnError>): RequestResult<TurnReportsCreateTurnReportResponses, unknown, ThrowOnError> => (options.client ?? client).post<TurnReportsCreateTurnReportResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/TurnReports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const turnReportsPut = <ThrowOnError extends boolean = false>(options: Options<TurnReportsPutData, ThrowOnError>): RequestResult<TurnReportsPutResponses, unknown, ThrowOnError> => (options.client ?? client).put<TurnReportsPutResponses, unknown, ThrowOnError>({
    url: '/TurnReports/{reportId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const turnReportsGetMissingReports = <ThrowOnError extends boolean = false>(options?: Options<TurnReportsGetMissingReportsData, ThrowOnError>): RequestResult<TurnReportsGetMissingReportsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TurnReportsGetMissingReportsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/TurnReports/TurnsWithoutReport',
    ...options
});

export const turnReportsGet2 = <ThrowOnError extends boolean = false>(options: Options<TurnReportsGet2Data, ThrowOnError>): RequestResult<TurnReportsGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<TurnReportsGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/TurnReports/{id}',
    ...options
});

export const subscriptionsGetNotificationTypes = <ThrowOnError extends boolean = false>(options?: Options<SubscriptionsGetNotificationTypesData, ThrowOnError>): RequestResult<SubscriptionsGetNotificationTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SubscriptionsGetNotificationTypesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/notification-types',
    ...options
});

export const subscriptionsGetSubscriptions = <ThrowOnError extends boolean = false>(options: Options<SubscriptionsGetSubscriptionsData, ThrowOnError>): RequestResult<SubscriptionsGetSubscriptionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SubscriptionsGetSubscriptionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/publisher/{publisherId}',
    ...options
});

export const subscriptionsUpdateSubscriptions = <ThrowOnError extends boolean = false>(options: Options<SubscriptionsUpdateSubscriptionsData, ThrowOnError>): RequestResult<SubscriptionsUpdateSubscriptionsResponses, unknown, ThrowOnError> => (options.client ?? client).put<SubscriptionsUpdateSubscriptionsResponses, unknown, ThrowOnError>({ url: '/publisher/{publisherId}', ...options });

export const subscriptionsGetSubscription = <ThrowOnError extends boolean = false>(options: Options<SubscriptionsGetSubscriptionData, ThrowOnError>): RequestResult<SubscriptionsGetSubscriptionResponses, unknown, ThrowOnError> => (options.client ?? client).get<SubscriptionsGetSubscriptionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/publisher/{publisherId}/notification/{notificationTypeId}',
    ...options
});

export const subscriptionsUpdateSubscription = <ThrowOnError extends boolean = false>(options: Options<SubscriptionsUpdateSubscriptionData, ThrowOnError>): RequestResult<SubscriptionsUpdateSubscriptionResponses, unknown, ThrowOnError> => (options.client ?? client).put<SubscriptionsUpdateSubscriptionResponses, unknown, ThrowOnError>({ url: '/publisher/{publisherId}/notification', ...options });

export const shiftsGetShiftsWithoutTeamLeader = <ThrowOnError extends boolean = false>(options?: Options<ShiftsGetShiftsWithoutTeamLeaderData, ThrowOnError>): RequestResult<ShiftsGetShiftsWithoutTeamLeaderResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ShiftsGetShiftsWithoutTeamLeaderResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/withoutTeamLeader',
    ...options
});

export const shiftsGetShiftsForCalendarWeek = <ThrowOnError extends boolean = false>(options: Options<ShiftsGetShiftsForCalendarWeekData, ThrowOnError>): RequestResult<ShiftsGetShiftsForCalendarWeekResponses, unknown, ThrowOnError> => (options.client ?? client).get<ShiftsGetShiftsForCalendarWeekResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/cw/{calendarYear}/{calendarWeek}',
    ...options
});

export const shiftsGetShiftsForDate = <ThrowOnError extends boolean = false>(options: Options<ShiftsGetShiftsForDateData, ThrowOnError>): RequestResult<ShiftsGetShiftsForDateResponses, unknown, ThrowOnError> => (options.client ?? client).get<ShiftsGetShiftsForDateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/{year}/{month}/{day}',
    ...options
});

export const shiftsGetApplicationEvents = <ThrowOnError extends boolean = false>(options: Options<ShiftsGetApplicationEventsData, ThrowOnError>): RequestResult<ShiftsGetApplicationEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ShiftsGetApplicationEventsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/ApplicationEvents/{calendarYear}/{calendarWeek}',
    ...options
});

export const shiftsReleaseShift = <ThrowOnError extends boolean = false>(options: Options<ShiftsReleaseShiftData, ThrowOnError>): RequestResult<ShiftsReleaseShiftResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftsReleaseShiftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/{id}/release',
    ...options
});

export const shiftsUnreleaseShift = <ThrowOnError extends boolean = false>(options: Options<ShiftsUnreleaseShiftData, ThrowOnError>): RequestResult<ShiftsUnreleaseShiftResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftsUnreleaseShiftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/{id}/revocation',
    ...options
});

export const shiftsFreezeShift = <ThrowOnError extends boolean = false>(options: Options<ShiftsFreezeShiftData, ThrowOnError>): RequestResult<ShiftsFreezeShiftResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftsFreezeShiftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/{id}/freeze',
    ...options
});

export const shiftsFreezeShifts = <ThrowOnError extends boolean = false>(options: Options<ShiftsFreezeShiftsData, ThrowOnError>): RequestResult<ShiftsFreezeShiftsResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftsFreezeShiftsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/freeze',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const shiftsThawShift = <ThrowOnError extends boolean = false>(options: Options<ShiftsThawShiftData, ThrowOnError>): RequestResult<ShiftsThawShiftResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftsThawShiftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/{id}/thawing',
    ...options
});

export const shiftsCommitShift = <ThrowOnError extends boolean = false>(options: Options<ShiftsCommitShiftData, ThrowOnError>): RequestResult<ShiftsCommitShiftResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftsCommitShiftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/{id}/committal',
    ...options
});

export const shiftsGetIssues = <ThrowOnError extends boolean = false>(options: Options<ShiftsGetIssuesData, ThrowOnError>): RequestResult<ShiftsGetIssuesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ShiftsGetIssuesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/{id}/issues',
    ...options
});

export const shiftsGetIssuesAll = <ThrowOnError extends boolean = false>(options?: Options<ShiftsGetIssuesAllData, ThrowOnError>): RequestResult<ShiftsGetIssuesAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ShiftsGetIssuesAllResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/issues',
    ...options
});

export const shiftsFinalizeShift = <ThrowOnError extends boolean = false>(options: Options<ShiftsFinalizeShiftData, ThrowOnError>): RequestResult<ShiftsFinalizeShiftResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftsFinalizeShiftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/{id}/finalization',
    ...options
});

export const shiftsCancel = <ThrowOnError extends boolean = false>(options: Options<ShiftsCancelData, ThrowOnError>): RequestResult<ShiftsCancelResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftsCancelResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/{id}/cancellation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const shiftsScaffold = <ThrowOnError extends boolean = false>(options: Options<ShiftsScaffoldData, ThrowOnError>): RequestResult<ShiftsScaffoldResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftsScaffoldResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Shifts/scaffold',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const shiftsGet = <ThrowOnError extends boolean = false>(options?: Options<ShiftsGetData, ThrowOnError>): RequestResult<ShiftsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ShiftsGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Shifts',
    ...options
});

export const shiftsPost = <ThrowOnError extends boolean = false>(options: Options<ShiftsPostData, ThrowOnError>): RequestResult<ShiftsPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftsPostResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Shifts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const shiftsDelete = <ThrowOnError extends boolean = false>(options: Options<ShiftsDeleteData, ThrowOnError>): RequestResult<ShiftsDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ShiftsDeleteResponses, unknown, ThrowOnError>({ url: '/Shifts/{id}', ...options });

export const shiftsGet2 = <ThrowOnError extends boolean = false>(options: Options<ShiftsGet2Data, ThrowOnError>): RequestResult<ShiftsGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ShiftsGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Shifts/{id}',
    ...options
});

export const shiftsPut = <ThrowOnError extends boolean = false>(options: Options<ShiftsPutData, ThrowOnError>): RequestResult<ShiftsPutResponses, unknown, ThrowOnError> => (options.client ?? client).put<ShiftsPutResponses, unknown, ThrowOnError>({
    url: '/Shifts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const shiftApplicationsGet = <ThrowOnError extends boolean = false>(options?: Options<ShiftApplicationsGetData, ThrowOnError>): RequestResult<ShiftApplicationsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ShiftApplicationsGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/ShiftApplications',
    ...options
});

export const shiftApplicationsApplyForShift = <ThrowOnError extends boolean = false>(options: Options<ShiftApplicationsApplyForShiftData, ThrowOnError>): RequestResult<ShiftApplicationsApplyForShiftResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShiftApplicationsApplyForShiftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/ShiftApplications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const shiftApplicationsRevokeShiftApplication = <ThrowOnError extends boolean = false>(options: Options<ShiftApplicationsRevokeShiftApplicationData, ThrowOnError>): RequestResult<ShiftApplicationsRevokeShiftApplicationResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ShiftApplicationsRevokeShiftApplicationResponses, unknown, ThrowOnError>({ url: '/ShiftApplications/{shiftApplicationId}', ...options });

export const shiftApplicationsGet2 = <ThrowOnError extends boolean = false>(options: Options<ShiftApplicationsGet2Data, ThrowOnError>): RequestResult<ShiftApplicationsGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<ShiftApplicationsGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/ShiftApplications/{id}',
    ...options
});

export const settingsGetSettings = <ThrowOnError extends boolean = false>(options: Options<SettingsGetSettingsData, ThrowOnError>): RequestResult<SettingsGetSettingsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SettingsGetSettingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Settings/{categoryKey}',
    ...options
});

export const settingsSetSettings = <ThrowOnError extends boolean = false>(options: Options<SettingsSetSettingsData, ThrowOnError>): RequestResult<SettingsSetSettingsResponses, unknown, ThrowOnError> => (options.client ?? client).put<SettingsSetSettingsResponses, unknown, ThrowOnError>({
    url: '/Settings/{categoryKey}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const settingsGetSettings2 = <ThrowOnError extends boolean = false>(options: Options<SettingsGetSettings2Data, ThrowOnError>): RequestResult<SettingsGetSettings2Responses, unknown, ThrowOnError> => (options.client ?? client).get<SettingsGetSettings2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Settings/{categoryKey}/{key}',
    ...options
});

export const settingsSetSettings2 = <ThrowOnError extends boolean = false>(options: Options<SettingsSetSettings2Data, ThrowOnError>): RequestResult<SettingsSetSettings2Responses, unknown, ThrowOnError> => (options.client ?? client).put<SettingsSetSettings2Responses, unknown, ThrowOnError>({
    url: '/Settings/{categoryKey}/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const settingsGetSettingsAll = <ThrowOnError extends boolean = false>(options?: Options<SettingsGetSettingsAllData, ThrowOnError>): RequestResult<SettingsGetSettingsAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SettingsGetSettingsAllResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Settings',
    ...options
});

export const settingsValidTimeZoneInfos = <ThrowOnError extends boolean = false>(options?: Options<SettingsValidTimeZoneInfosData, ThrowOnError>): RequestResult<SettingsValidTimeZoneInfosResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SettingsValidTimeZoneInfosResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Settings/planning/timezones',
    ...options
});

/**
 * @deprecated
 */
export const routeSchedulesDeleteRouteSchedule = <ThrowOnError extends boolean = false>(options: Options<RouteSchedulesDeleteRouteScheduleData, ThrowOnError>): RequestResult<RouteSchedulesDeleteRouteScheduleResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RouteSchedulesDeleteRouteScheduleResponses, unknown, ThrowOnError>({ url: '/RouteSchedules/{routeId}', ...options });

/**
 * @deprecated
 */
export const routeSchedulesGetRouteSchedule = <ThrowOnError extends boolean = false>(options: Options<RouteSchedulesGetRouteScheduleData, ThrowOnError>): RequestResult<RouteSchedulesGetRouteScheduleResponses, unknown, ThrowOnError> => (options.client ?? client).get<RouteSchedulesGetRouteScheduleResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/RouteSchedules/{routeId}',
    ...options
});

/**
 * @deprecated
 */
export const routeSchedulesSaveRouteSchedule = <ThrowOnError extends boolean = false>(options: Options<RouteSchedulesSaveRouteScheduleData, ThrowOnError>): RequestResult<RouteSchedulesSaveRouteScheduleResponses, unknown, ThrowOnError> => (options.client ?? client).post<RouteSchedulesSaveRouteScheduleResponses, unknown, ThrowOnError>({
    url: '/RouteSchedules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const routesPrioritize = <ThrowOnError extends boolean = false>(options: Options<RoutesPrioritizeData, ThrowOnError>): RequestResult<RoutesPrioritizeResponses, unknown, ThrowOnError> => (options.client ?? client).post<RoutesPrioritizeResponses, unknown, ThrowOnError>({
    url: '/Routes/prioritize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const routesGet = <ThrowOnError extends boolean = false>(options?: Options<RoutesGetData, ThrowOnError>): RequestResult<RoutesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RoutesGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Routes',
    ...options
});

/**
 * @deprecated
 */
export const routesPost = <ThrowOnError extends boolean = false>(options: Options<RoutesPostData, ThrowOnError>): RequestResult<RoutesPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<RoutesPostResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Routes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const routesDelete = <ThrowOnError extends boolean = false>(options: Options<RoutesDeleteData, ThrowOnError>): RequestResult<RoutesDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RoutesDeleteResponses, unknown, ThrowOnError>({ url: '/Routes/{id}', ...options });

/**
 * @deprecated
 */
export const routesGet2 = <ThrowOnError extends boolean = false>(options: Options<RoutesGet2Data, ThrowOnError>): RequestResult<RoutesGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<RoutesGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Routes/{id}',
    ...options
});

/**
 * @deprecated
 */
export const routesPut = <ThrowOnError extends boolean = false>(options: Options<RoutesPutData, ThrowOnError>): RequestResult<RoutesPutResponses, unknown, ThrowOnError> => (options.client ?? client).put<RoutesPutResponses, unknown, ThrowOnError>({
    url: '/Routes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const recurrentApplicationsGetAllOfPublisher = <ThrowOnError extends boolean = false>(options: Options<RecurrentApplicationsGetAllOfPublisherData, ThrowOnError>): RequestResult<RecurrentApplicationsGetAllOfPublisherResponses, unknown, ThrowOnError> => (options.client ?? client).get<RecurrentApplicationsGetAllOfPublisherResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/RecurrentApplications/{publisherId}',
    ...options
});

export const recurrentApplicationsPost = <ThrowOnError extends boolean = false>(options: Options<RecurrentApplicationsPostData, ThrowOnError>): RequestResult<RecurrentApplicationsPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<RecurrentApplicationsPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/RecurrentApplications/{publisherId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const recurrentApplicationsGetSingle = <ThrowOnError extends boolean = false>(options: Options<RecurrentApplicationsGetSingleData, ThrowOnError>): RequestResult<RecurrentApplicationsGetSingleResponses, unknown, ThrowOnError> => (options.client ?? client).get<RecurrentApplicationsGetSingleResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/RecurrentApplications/{publisherId}/{id}',
    ...options
});

export const recurrentApplicationsPut = <ThrowOnError extends boolean = false>(options: Options<RecurrentApplicationsPutData, ThrowOnError>): RequestResult<RecurrentApplicationsPutResponses, unknown, ThrowOnError> => (options.client ?? client).put<RecurrentApplicationsPutResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/RecurrentApplications/{publisherId}/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const recurrentApplicationsDelete = <ThrowOnError extends boolean = false>(options: Options<RecurrentApplicationsDeleteData, ThrowOnError>): RequestResult<RecurrentApplicationsDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RecurrentApplicationsDeleteResponses, unknown, ThrowOnError>({ url: '/RecurrentApplications/{publisherId}/{applicationId}', ...options });

/**
 * @deprecated
 */
export const publishersGetMe = <ThrowOnError extends boolean = false>(options?: Options<PublishersGetMeData, ThrowOnError>): RequestResult<PublishersGetMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PublishersGetMeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Publishers/my',
    ...options
});

/**
 * @deprecated
 */
export const publishersSearch = <ThrowOnError extends boolean = false>(options?: Options<PublishersSearchData, ThrowOnError>): RequestResult<PublishersSearchResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PublishersSearchResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Publishers/search',
    ...options
});

/**
 * @deprecated
 */
export const publishersExport = <ThrowOnError extends boolean = false>(options?: Options<PublishersExportData, ThrowOnError>): RequestResult<PublishersExportResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PublishersExportResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Publishers/export/xlsx',
    ...options
});

/**
 * @deprecated
 */
export const publishersImport = <ThrowOnError extends boolean = false>(options?: Options<PublishersImportData, ThrowOnError>): RequestResult<PublishersImportResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PublishersImportResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Publishers/import/csv',
    ...options
});

/**
 * @deprecated
 */
export const publishersImportAll = <ThrowOnError extends boolean = false>(options: Options<PublishersImportAllData, ThrowOnError>): RequestResult<PublishersImportAllResponses, unknown, ThrowOnError> => (options.client ?? client).post<PublishersImportAllResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Publishers/import/csv',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const publishersGetProfile = <ThrowOnError extends boolean = false>(options: Options<PublishersGetProfileData, ThrowOnError>): RequestResult<PublishersGetProfileResponses, unknown, ThrowOnError> => (options.client ?? client).get<PublishersGetProfileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Publishers/{id}/profile',
    ...options
});

/**
 * @deprecated
 */
export const publishersSetProfile = <ThrowOnError extends boolean = false>(options: Options<PublishersSetProfileData, ThrowOnError>): RequestResult<PublishersSetProfileResponses, unknown, ThrowOnError> => (options.client ?? client).put<PublishersSetProfileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Publishers/{id}/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const publishersExportVcard = <ThrowOnError extends boolean = false>(options?: Options<PublishersExportVcardData, ThrowOnError>): RequestResult<PublishersExportVcardResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PublishersExportVcardResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Publishers/export/vcards',
    ...options
});

/**
 * @deprecated
 */
export const publishersLock = <ThrowOnError extends boolean = false>(options: Options<PublishersLockData, ThrowOnError>): RequestResult<PublishersLockResponses, unknown, ThrowOnError> => (options.client ?? client).post<PublishersLockResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Publishers/{id}/lock',
    ...options
});

/**
 * @deprecated
 */
export const publishersInvite = <ThrowOnError extends boolean = false>(options: Options<PublishersInviteData, ThrowOnError>): RequestResult<PublishersInviteResponses, unknown, ThrowOnError> => (options.client ?? client).post<PublishersInviteResponses, unknown, ThrowOnError>({
    url: '/Publishers/invitation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const publishersGet = <ThrowOnError extends boolean = false>(options?: Options<PublishersGetData, ThrowOnError>): RequestResult<PublishersGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PublishersGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Publishers',
    ...options
});

/**
 * @deprecated
 */
export const publishersPost = <ThrowOnError extends boolean = false>(options: Options<PublishersPostData, ThrowOnError>): RequestResult<PublishersPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<PublishersPostResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Publishers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const publishersDelete = <ThrowOnError extends boolean = false>(options: Options<PublishersDeleteData, ThrowOnError>): RequestResult<PublishersDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<PublishersDeleteResponses, unknown, ThrowOnError>({ url: '/Publishers/{id}', ...options });

/**
 * @deprecated
 */
export const publishersGet2 = <ThrowOnError extends boolean = false>(options: Options<PublishersGet2Data, ThrowOnError>): RequestResult<PublishersGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<PublishersGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Publishers/{id}',
    ...options
});

/**
 * @deprecated
 */
export const publishersPut = <ThrowOnError extends boolean = false>(options: Options<PublishersPutData, ThrowOnError>): RequestResult<PublishersPutResponses, unknown, ThrowOnError> => (options.client ?? client).put<PublishersPutResponses, unknown, ThrowOnError>({
    url: '/Publishers/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const planningSupportPerformPlanning = <ThrowOnError extends boolean = false>(options: Options<PlanningSupportPerformPlanningData, ThrowOnError>): RequestResult<PlanningSupportPerformPlanningResponses, unknown, ThrowOnError> => (options.client ?? client).post<PlanningSupportPerformPlanningResponses, unknown, ThrowOnError>({
    url: '/PlanningSupport/plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const planningSupportGenerateDraft = <ThrowOnError extends boolean = false>(options: Options<PlanningSupportGenerateDraftData, ThrowOnError>): RequestResult<PlanningSupportGenerateDraftResponses, unknown, ThrowOnError> => (options.client ?? client).post<PlanningSupportGenerateDraftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/PlanningSupport/drafts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const planningSupportGetDraft = <ThrowOnError extends boolean = false>(options: Options<PlanningSupportGetDraftData, ThrowOnError>): RequestResult<PlanningSupportGetDraftResponses, unknown, ThrowOnError> => (options.client ?? client).get<PlanningSupportGetDraftResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/PlanningSupport/drafts/{token}',
    ...options
});

export const newsEntriesUploadAttachment = <ThrowOnError extends boolean = false>(options?: Options<NewsEntriesUploadAttachmentData, ThrowOnError>): RequestResult<NewsEntriesUploadAttachmentResponses, unknown, ThrowOnError> => (options?.client ?? client).post<NewsEntriesUploadAttachmentResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/NewsEntries/Attachments',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

export const newsEntriesGetCurrentNews = <ThrowOnError extends boolean = false>(options?: Options<NewsEntriesGetCurrentNewsData, ThrowOnError>): RequestResult<NewsEntriesGetCurrentNewsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<NewsEntriesGetCurrentNewsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/NewsEntries/Current',
    ...options
});

export const newsEntriesMarkNewsEntryAsRead = <ThrowOnError extends boolean = false>(options: Options<NewsEntriesMarkNewsEntryAsReadData, ThrowOnError>): RequestResult<NewsEntriesMarkNewsEntryAsReadResponses, unknown, ThrowOnError> => (options.client ?? client).post<NewsEntriesMarkNewsEntryAsReadResponses, unknown, ThrowOnError>({ url: '/NewsEntries/{newsEntryId}/{newsEntryRev}/read', ...options });

export const newsEntriesMarkNewsEntryAsUnread = <ThrowOnError extends boolean = false>(options: Options<NewsEntriesMarkNewsEntryAsUnreadData, ThrowOnError>): RequestResult<NewsEntriesMarkNewsEntryAsUnreadResponses, unknown, ThrowOnError> => (options.client ?? client).post<NewsEntriesMarkNewsEntryAsUnreadResponses, unknown, ThrowOnError>({ url: '/NewsEntries/{newsEntryId}/unread', ...options });

export const newsEntriesGetNewsStatistics = <ThrowOnError extends boolean = false>(options: Options<NewsEntriesGetNewsStatisticsData, ThrowOnError>): RequestResult<NewsEntriesGetNewsStatisticsResponses, unknown, ThrowOnError> => (options.client ?? client).get<NewsEntriesGetNewsStatisticsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/NewsEntries/{newsEntryId}/statistics',
    ...options
});

export const newsEntriesGet = <ThrowOnError extends boolean = false>(options?: Options<NewsEntriesGetData, ThrowOnError>): RequestResult<NewsEntriesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<NewsEntriesGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/NewsEntries',
    ...options
});

export const newsEntriesPost = <ThrowOnError extends boolean = false>(options: Options<NewsEntriesPostData, ThrowOnError>): RequestResult<NewsEntriesPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<NewsEntriesPostResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/NewsEntries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const newsEntriesDelete = <ThrowOnError extends boolean = false>(options: Options<NewsEntriesDeleteData, ThrowOnError>): RequestResult<NewsEntriesDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<NewsEntriesDeleteResponses, unknown, ThrowOnError>({ url: '/NewsEntries/{id}', ...options });

export const newsEntriesGet2 = <ThrowOnError extends boolean = false>(options: Options<NewsEntriesGet2Data, ThrowOnError>): RequestResult<NewsEntriesGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<NewsEntriesGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/NewsEntries/{id}',
    ...options
});

export const newsEntriesPut = <ThrowOnError extends boolean = false>(options: Options<NewsEntriesPutData, ThrowOnError>): RequestResult<NewsEntriesPutResponses, unknown, ThrowOnError> => (options.client ?? client).put<NewsEntriesPutResponses, unknown, ThrowOnError>({
    url: '/NewsEntries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const languagesGet = <ThrowOnError extends boolean = false>(options?: Options<LanguagesGetData, ThrowOnError>): RequestResult<LanguagesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LanguagesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Languages',
    ...options
});

export const inAppNotificationsGetMyUnreadInAppNotifications = <ThrowOnError extends boolean = false>(options?: Options<InAppNotificationsGetMyUnreadInAppNotificationsData, ThrowOnError>): RequestResult<InAppNotificationsGetMyUnreadInAppNotificationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InAppNotificationsGetMyUnreadInAppNotificationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/InAppNotifications/my/unread',
    ...options
});

export const inAppNotificationsGetMyInAppNotifications = <ThrowOnError extends boolean = false>(options?: Options<InAppNotificationsGetMyInAppNotificationsData, ThrowOnError>): RequestResult<InAppNotificationsGetMyInAppNotificationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<InAppNotificationsGetMyInAppNotificationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/InAppNotifications/my',
    ...options
});

export const inAppNotificationsMarkAsRead = <ThrowOnError extends boolean = false>(options: Options<InAppNotificationsMarkAsReadData, ThrowOnError>): RequestResult<InAppNotificationsMarkAsReadResponses, unknown, ThrowOnError> => (options.client ?? client).post<InAppNotificationsMarkAsReadResponses, unknown, ThrowOnError>({ url: '/InAppNotifications/{id}/read-confirmation', ...options });

export const blobsGetBlob = <ThrowOnError extends boolean = false>(options: Options<BlobsGetBlobData, ThrowOnError>): RequestResult<BlobsGetBlobResponses, unknown, ThrowOnError> => (options.client ?? client).get<BlobsGetBlobResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Blobs/{blobId}',
    ...options
});

export const documentsGetCircuitReport = <ThrowOnError extends boolean = false>(options: Options<DocumentsGetCircuitReportData, ThrowOnError>): RequestResult<DocumentsGetCircuitReportResponses, unknown, ThrowOnError> => (options.client ?? client).get<DocumentsGetCircuitReportResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Documents/CircuitReports/{identifier}',
    ...options
});

export const experiencesGetAll = <ThrowOnError extends boolean = false>(options?: Options<ExperiencesGetAllData, ThrowOnError>): RequestResult<ExperiencesGetAllResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ExperiencesGetAllResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Experiences',
    ...options
});

export const experiencesCreateExperience = <ThrowOnError extends boolean = false>(options: Options<ExperiencesCreateExperienceData, ThrowOnError>): RequestResult<ExperiencesCreateExperienceResponses, unknown, ThrowOnError> => (options.client ?? client).post<ExperiencesCreateExperienceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Experiences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const experiencesGet = <ThrowOnError extends boolean = false>(options: Options<ExperiencesGetData, ThrowOnError>): RequestResult<ExperiencesGetResponses, unknown, ThrowOnError> => (options.client ?? client).get<ExperiencesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Experiences/{id}',
    ...options
});

export const experiencesSetState = <ThrowOnError extends boolean = false>(options: Options<ExperiencesSetStateData, ThrowOnError>): RequestResult<ExperiencesSetStateResponses, unknown, ThrowOnError> => (options.client ?? client).put<ExperiencesSetStateResponses, unknown, ThrowOnError>({
    url: '/Experiences/{experienceId}/State',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const experiencesSetPositive = <ThrowOnError extends boolean = false>(options: Options<ExperiencesSetPositiveData, ThrowOnError>): RequestResult<ExperiencesSetPositiveResponses, unknown, ThrowOnError> => (options.client ?? client).put<ExperiencesSetPositiveResponses, unknown, ThrowOnError>({
    url: '/Experiences/{experienceId}/IsPositive',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const experiencesSetTitle = <ThrowOnError extends boolean = false>(options: Options<ExperiencesSetTitleData, ThrowOnError>): RequestResult<ExperiencesSetTitleResponses, unknown, ThrowOnError> => (options.client ?? client).put<ExperiencesSetTitleResponses, unknown, ThrowOnError>({
    url: '/Experiences/{experienceId}/Title',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const experiencesGetEvents = <ThrowOnError extends boolean = false>(options: Options<ExperiencesGetEventsData, ThrowOnError>): RequestResult<ExperiencesGetEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ExperiencesGetEventsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Experiences/{experienceId}/Events',
    ...options
});

export const experiencesCreateEvent = <ThrowOnError extends boolean = false>(options: Options<ExperiencesCreateEventData, ThrowOnError>): RequestResult<ExperiencesCreateEventResponses, unknown, ThrowOnError> => (options.client ?? client).post<ExperiencesCreateEventResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Experiences/{experienceId}/Events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const experiencesUpdateEvent = <ThrowOnError extends boolean = false>(options: Options<ExperiencesUpdateEventData, ThrowOnError>): RequestResult<ExperiencesUpdateEventResponses, unknown, ThrowOnError> => (options.client ?? client).put<ExperiencesUpdateEventResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Experiences/{experienceId}/Events/{eventId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const errorsHttp400 = <ThrowOnError extends boolean = false>(options?: Options<ErrorsHttp400Data, ThrowOnError>): RequestResult<ErrorsHttp400Responses, unknown, ThrowOnError> => (options?.client ?? client).get<ErrorsHttp400Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Errors/http400',
    ...options
});

export const errorsHttp500 = <ThrowOnError extends boolean = false>(options?: Options<ErrorsHttp500Data, ThrowOnError>): RequestResult<ErrorsHttp500Responses, unknown, ThrowOnError> => (options?.client ?? client).get<ErrorsHttp500Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Errors/http500',
    ...options
});

/**
 * @deprecated
 */
export const depotsGet = <ThrowOnError extends boolean = false>(options?: Options<DepotsGetData, ThrowOnError>): RequestResult<DepotsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DepotsGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Depots',
    ...options
});

/**
 * @deprecated
 */
export const depotsPost = <ThrowOnError extends boolean = false>(options: Options<DepotsPostData, ThrowOnError>): RequestResult<DepotsPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<DepotsPostResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Depots',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const depotsDelete = <ThrowOnError extends boolean = false>(options: Options<DepotsDeleteData, ThrowOnError>): RequestResult<DepotsDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DepotsDeleteResponses, unknown, ThrowOnError>({ url: '/Depots/{id}', ...options });

/**
 * @deprecated
 */
export const depotsGet2 = <ThrowOnError extends boolean = false>(options: Options<DepotsGet2Data, ThrowOnError>): RequestResult<DepotsGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<DepotsGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Depots/{id}',
    ...options
});

/**
 * @deprecated
 */
export const depotsPut = <ThrowOnError extends boolean = false>(options: Options<DepotsPutData, ThrowOnError>): RequestResult<DepotsPutResponses, unknown, ThrowOnError> => (options.client ?? client).put<DepotsPutResponses, unknown, ThrowOnError>({
    url: '/Depots/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const dashboardsGetMyDashboard = <ThrowOnError extends boolean = false>(options?: Options<DashboardsGetMyDashboardData, ThrowOnError>): RequestResult<DashboardsGetMyDashboardResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DashboardsGetMyDashboardResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Dashboards/my',
    ...options
});

export const dashboardsGet = <ThrowOnError extends boolean = false>(options: Options<DashboardsGetData, ThrowOnError>): RequestResult<DashboardsGetResponses, unknown, ThrowOnError> => (options.client ?? client).get<DashboardsGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Dashboards/{publisherId}',
    ...options
});

export const cutoffDatesGet = <ThrowOnError extends boolean = false>(options?: Options<CutoffDatesGetData, ThrowOnError>): RequestResult<CutoffDatesGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CutoffDatesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/CutoffDates',
    ...options
});

export const cutoffDatesReleaseUntil = <ThrowOnError extends boolean = false>(options: Options<CutoffDatesReleaseUntilData, ThrowOnError>): RequestResult<CutoffDatesReleaseUntilResponses, unknown, ThrowOnError> => (options.client ?? client).post<CutoffDatesReleaseUntilResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/CutoffDates/release',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const cutoffDatesReleaseUntilDryRun = <ThrowOnError extends boolean = false>(options: Options<CutoffDatesReleaseUntilDryRunData, ThrowOnError>): RequestResult<CutoffDatesReleaseUntilDryRunResponses, unknown, ThrowOnError> => (options.client ?? client).post<CutoffDatesReleaseUntilDryRunResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/CutoffDates/release/dryRun',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const cutoffDatesFinalizeUntil = <ThrowOnError extends boolean = false>(options: Options<CutoffDatesFinalizeUntilData, ThrowOnError>): RequestResult<CutoffDatesFinalizeUntilResponses, unknown, ThrowOnError> => (options.client ?? client).post<CutoffDatesFinalizeUntilResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/CutoffDates/finalization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const cutoffDatesFinalizeUntilDryRun = <ThrowOnError extends boolean = false>(options: Options<CutoffDatesFinalizeUntilDryRunData, ThrowOnError>): RequestResult<CutoffDatesFinalizeUntilDryRunResponses, unknown, ThrowOnError> => (options.client ?? client).post<CutoffDatesFinalizeUntilDryRunResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/CutoffDates/finalization/dryRun',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const congregationsGet = <ThrowOnError extends boolean = false>(options?: Options<CongregationsGetData, ThrowOnError>): RequestResult<CongregationsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CongregationsGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Congregations',
    ...options
});

/**
 * @deprecated
 */
export const congregationsPost = <ThrowOnError extends boolean = false>(options: Options<CongregationsPostData, ThrowOnError>): RequestResult<CongregationsPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<CongregationsPostResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Congregations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const congregationsDelete = <ThrowOnError extends boolean = false>(options: Options<CongregationsDeleteData, ThrowOnError>): RequestResult<CongregationsDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<CongregationsDeleteResponses, unknown, ThrowOnError>({ url: '/Congregations/{id}', ...options });

/**
 * @deprecated
 */
export const congregationsGet2 = <ThrowOnError extends boolean = false>(options: Options<CongregationsGet2Data, ThrowOnError>): RequestResult<CongregationsGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<CongregationsGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Congregations/{id}',
    ...options
});

/**
 * @deprecated
 */
export const congregationsPut = <ThrowOnError extends boolean = false>(options: Options<CongregationsPutData, ThrowOnError>): RequestResult<CongregationsPutResponses, unknown, ThrowOnError> => (options.client ?? client).put<CongregationsPutResponses, unknown, ThrowOnError>({
    url: '/Congregations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const circuitsGet = <ThrowOnError extends boolean = false>(options?: Options<CircuitsGetData, ThrowOnError>): RequestResult<CircuitsGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CircuitsGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Circuits',
    ...options
});

/**
 * @deprecated
 */
export const circuitsPost = <ThrowOnError extends boolean = false>(options: Options<CircuitsPostData, ThrowOnError>): RequestResult<CircuitsPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<CircuitsPostResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Circuits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * @deprecated
 */
export const circuitsDelete = <ThrowOnError extends boolean = false>(options: Options<CircuitsDeleteData, ThrowOnError>): RequestResult<CircuitsDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<CircuitsDeleteResponses, unknown, ThrowOnError>({ url: '/Circuits/{id}', ...options });

/**
 * @deprecated
 */
export const circuitsGet2 = <ThrowOnError extends boolean = false>(options: Options<CircuitsGet2Data, ThrowOnError>): RequestResult<CircuitsGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<CircuitsGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Circuits/{id}',
    ...options
});

/**
 * @deprecated
 */
export const circuitsPut = <ThrowOnError extends boolean = false>(options: Options<CircuitsPutData, ThrowOnError>): RequestResult<CircuitsPutResponses, unknown, ThrowOnError> => (options.client ?? client).put<CircuitsPutResponses, unknown, ThrowOnError>({
    url: '/Circuits/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const calendarsGetMyCalendarUrl = <ThrowOnError extends boolean = false>(options?: Options<CalendarsGetMyCalendarUrlData, ThrowOnError>): RequestResult<CalendarsGetMyCalendarUrlResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CalendarsGetMyCalendarUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Calendars/my/url',
    ...options
});

export const calendarsDisableCalendar = <ThrowOnError extends boolean = false>(options?: Options<CalendarsDisableCalendarData, ThrowOnError>): RequestResult<CalendarsDisableCalendarResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<CalendarsDisableCalendarResponses, unknown, ThrowOnError>({ url: '/Calendars/my', ...options });

export const calendarsCreateCalendar = <ThrowOnError extends boolean = false>(options?: Options<CalendarsCreateCalendarData, ThrowOnError>): RequestResult<CalendarsCreateCalendarResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CalendarsCreateCalendarResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Calendars/my',
    ...options
});

/**
 * @deprecated
 */
export const auditGet = <ThrowOnError extends boolean = false>(options?: Options<AuditGetData, ThrowOnError>): RequestResult<AuditGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuditGetResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Audit',
    ...options
});

/**
 * @deprecated
 */
export const auditGet2 = <ThrowOnError extends boolean = false>(options: Options<AuditGet2Data, ThrowOnError>): RequestResult<AuditGet2Responses, unknown, ThrowOnError> => (options.client ?? client).get<AuditGet2Responses, unknown, ThrowOnError>({
    responseType: 'blob',
    url: '/Audit/{id}',
    ...options
});

export const analyticsGetMonthReports = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsGetMonthReportsData, ThrowOnError>): RequestResult<AnalyticsGetMonthReportsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AnalyticsGetMonthReportsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Analytics/MonthReports',
    ...options
});

export const analyticsGetMonthReport = <ThrowOnError extends boolean = false>(options: Options<AnalyticsGetMonthReportData, ThrowOnError>): RequestResult<AnalyticsGetMonthReportResponses, unknown, ThrowOnError> => (options.client ?? client).get<AnalyticsGetMonthReportResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Analytics/MonthReport/{year}/{month}',
    ...options
});

export const analyticsGetBranchReports = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsGetBranchReportsData, ThrowOnError>): RequestResult<AnalyticsGetBranchReportsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AnalyticsGetBranchReportsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Analytics/BranchReports',
    ...options
});

export const analyticsGetBranchReport = <ThrowOnError extends boolean = false>(options: Options<AnalyticsGetBranchReportData, ThrowOnError>): RequestResult<AnalyticsGetBranchReportResponses, unknown, ThrowOnError> => (options.client ?? client).get<AnalyticsGetBranchReportResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Analytics/BranchReports/{year}/{month}',
    ...options
});

export const analyticsGetCircuitReports = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsGetCircuitReportsData, ThrowOnError>): RequestResult<AnalyticsGetCircuitReportsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AnalyticsGetCircuitReportsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Analytics/CircuitReports',
    ...options
});

export const analyticsGetCircuitReports2 = <ThrowOnError extends boolean = false>(options: Options<AnalyticsGetCircuitReports2Data, ThrowOnError>): RequestResult<AnalyticsGetCircuitReports2Responses, unknown, ThrowOnError> => (options.client ?? client).get<AnalyticsGetCircuitReports2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Analytics/CircuitReports/{year}/{quarter}',
    ...options
});

export const analyticsProlongCircuitReportAvailability = <ThrowOnError extends boolean = false>(options: Options<AnalyticsProlongCircuitReportAvailabilityData, ThrowOnError>): RequestResult<AnalyticsProlongCircuitReportAvailabilityResponses, unknown, ThrowOnError> => (options.client ?? client).post<AnalyticsProlongCircuitReportAvailabilityResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Analytics/CircuitReports/{year}/{quarter}/{circuitId}/prolong',
    ...options
});

export const analyticsGetAssignmentOverview = <ThrowOnError extends boolean = false>(options: Options<AnalyticsGetAssignmentOverviewData, ThrowOnError>): RequestResult<AnalyticsGetAssignmentOverviewResponses, unknown, ThrowOnError> => (options.client ?? client).get<AnalyticsGetAssignmentOverviewResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Analytics/assignmentOverview/{year}/{week}',
    ...options
});

export const analyticsTurnReports = <ThrowOnError extends boolean = false>(options: Options<AnalyticsTurnReportsData, ThrowOnError>): RequestResult<AnalyticsTurnReportsResponses, unknown, ThrowOnError> => (options.client ?? client).get<AnalyticsTurnReportsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Analytics/turnReports/{year}/{month}',
    ...options
});

export const absencesGet = <ThrowOnError extends boolean = false>(options: Options<AbsencesGetData, ThrowOnError>): RequestResult<AbsencesGetResponses, unknown, ThrowOnError> => (options.client ?? client).get<AbsencesGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Absences/{publisherId}',
    ...options
});

export const absencesPost = <ThrowOnError extends boolean = false>(options: Options<AbsencesPostData, ThrowOnError>): RequestResult<AbsencesPostResponses, unknown, ThrowOnError> => (options.client ?? client).post<AbsencesPostResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/Absences/{publisherId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const absencesDelete = <ThrowOnError extends boolean = false>(options: Options<AbsencesDeleteData, ThrowOnError>): RequestResult<AbsencesDeleteResponses, unknown, ThrowOnError> => (options.client ?? client).delete<AbsencesDeleteResponses, unknown, ThrowOnError>({ url: '/Absences/{publisherId}/{absenceId}', ...options });
